import { supabase } from "@/services/supabase/createClient";

export const deleteWorkspace = async (workspaceId: string) => {
  const { error } = await supabase.from("resources").delete().eq("resource_id", workspaceId);
  return { error };
};
